module.exports = __webpack_public_path__ + "img/logo-adults.4c3a778f.png";